import React, { useEffect, useState } from "react";
import axios from "axios";

export default function FileUpload() {
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [file, setFile] = useState(null);
  const [materialName, setMaterialName] = useState(""); // ✅ new field
  const [message, setMessage] = useState("");
  const [backendUrl, setBackendUrl] = useState("");

  // Load BACKEND_URL from config.js
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "/config.js";
    script.onload = () => {
      if (window.env?.BACKEND_URL) {
        console.log(" BACKEND_URL loaded:", window.env.BACKEND_URL);
        setBackendUrl(window.env.BACKEND_URL);
      } else {
        console.error(" BACKEND_URL not found in config.js");
      }
    };
    script.onerror = () => console.error(" Failed to load config.js");
    document.body.appendChild(script);
  }, []);

  // Fetch courses once backendUrl is loaded
  useEffect(() => {
    if (!backendUrl) return;
    axios
      .get(`${backendUrl}/courses`)
      .then((res) => setCourses(res.data))
      .catch((err) => {
        console.error("Failed to fetch courses", err);
        setMessage("Could not load courses.");
      });
  }, [backendUrl]);

  const handleUpload = async () => {
    if (!selectedCourse || !file || !materialName.trim()) {
      setMessage("⚠️ Please fill all fields.");
      return;
    }

    const formData = new FormData();
    formData.append("course_id", selectedCourse);
    formData.append("file", file);
    formData.append("material_name", materialName); // ✅ send to backend

    try {
      const res = await axios.post(`${backendUrl}/upload-course-file`, formData);
      setMessage(res.data.message);
      setFile(null);
      setMaterialName("");
    } catch (err) {
      console.error("Upload failed", err);
      setMessage("Upload failed. Please try again.");
    }
  };

  return (
    <div
      style={{
        maxWidth: "550px",
        margin: "20px auto",
        padding: "30px",
        backgroundColor: "#FFFFFF",
        borderRadius: "5px",
        boxShadow: "0 0 15px rgba(110, 111, 112, 0.2)",
        fontFamily: "Roboto, Arial, sans-serif",
        color: "#6E6F70",
        fontWeight: "200",
      }}
    >
      <h2
        style={{
          textAlign: "center",
          color: "#E30016",
          marginBottom: "30px",
          fontWeight: "700",
        }}
      >
        📤 Upload Course Materials
      </h2>

      {/* Course Dropdown */}
      <div style={{ marginBottom: "25px" }}>
        <label style={{ fontWeight: "200", display: "block", marginBottom: "8px" }}>
          Select Course:
        </label>
        <select
          value={selectedCourse}
          onChange={(e) => setSelectedCourse(e.target.value)}
          style={{
            padding: "10px",
            width: "95%",
            borderRadius: "6px",
            border: "1.5px solid #6E6F70",
            fontSize: "16px",
          }}
        >
          <option value="">-- Select Course --</option>
          {courses.map((course) => (
            <option key={course.course_id} value={course.course_id}>
              {course.course_name} (ID: {course.course_id})
            </option>
          ))}
        </select>
      </div>

      {/* Material Name Input */}
      <div style={{ marginBottom: "25px" }}>
        <label style={{ fontWeight: "200", display: "block", marginBottom: "8px" }}>
          Material Name:
        </label>
        <input
          type="text"
          value={materialName}
          onChange={(e) => setMaterialName(e.target.value)}
          placeholder="e.g., Introduction to Safety"
          style={{
            padding: "10px",
            width: "91%",
            borderRadius: "6px",
            border: "1.5px solid #6E6F70",
            fontSize: "16px",
          }}
        />
      </div>

      {/* File Input */}
      <div style={{ marginBottom: "25px" }}>
        <label style={{ fontWeight: "200", display: "block", marginBottom: "8px" }}>
          Choose File:
        </label>
        <input
          type="file"
          onChange={(e) => setFile(e.target.files[0])}
          style={{
            padding: "10px",
            width: "91%",
            borderRadius: "6px",
            border: "1.5px solid #6E6F70",
            fontSize: "16px",
          }}
        />
      </div>

      {/* Upload Button */}
      <div style={{ display: "flex", justifyContent: "center" }}>
        <button
          onClick={handleUpload}
          style={{
            width: "40%",
            padding: "12px",
            backgroundColor: "#E30016",
            color: "#FFFFFF",
            border: "none",
            borderRadius: "6px",
            fontSize: "18px",
            fontWeight: "700",
            cursor: "pointer",
            transition: "background-color 0.3s ease",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#a10010")}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#E30016")}
        >
          Upload File
        </button>
      </div>

      {/* Status Message */}
      {message && (
        <p
          style={{
            marginTop: "20px",
            fontWeight: "200",
            color: "#3e4041ff",
            textAlign: "center",
          }}
        >
          {message}
        </p>
      )}
    </div>
  );
}
